import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { sessionReducer as session } from './session';
import { devicesReducer as devices } from './devices';
import { positionsReducer as positions } from './positions';
import { geofencesReducer as geofences } from './geofences';
import { groupsReducer as groups } from './groups';
import { driversReducer as drivers } from './drivers';
import { maintenancesReducer as maintenances } from './maintenances';
import { usersReducer as users } from './users';
import { notificationSettingsReducer as notificationSettings } from './notificationSettings';
import { computedAttributesReducer as computedAttributes } from './computedAttributes';
import { statisticsReducer as statistics } from './statistics';
import { organizationReducer as organization_information } from "./organizationInfo";
import { devicesSelectedReducer as devicesSelected} from "./devicesSelected";
import { notificationsReducer as notifications } from "./notifications";
import { languageReducer as language } from "./language";
import { periodReducer as period} from "./period";
import { themeReducer as theme} from "./theme";
import { replayPositionsReducer as replayPositions } from './replayPositions';
import { routeReportReducer as routeReport } from './routeReport';
import { eventReportReducer as eventReport } from './eventReport';
import { tripReportReducer as tripReport } from './tripReport';
import { stopReportReducer as stopReport } from './stopReport';
import { summaryReportReducer as summaryReport } from './summaryReport';
import { chartReportReducer as chartReport } from './chartReport';
import { emissionsReportReducer as emissionsReport } from './emissionsReport';
import { devicesInfoReportReducer as devicesInfoReport } from './devicesInfoReport';
import { dashboardReportReducer as dashboardReport } from './dashboardReport';
import { appVersionReducer as appVersion } from './appVersion';

const reducer = combineReducers({
  session,
  devices,
  positions,
  geofences,
  groups,
  drivers,
  maintenances,
  users,
  notificationSettings,
  computedAttributes,
  statistics,
  organization_information,
  devicesSelected,
  notifications,
  language,
  period,
  theme,
  replayPositions,
  routeReport,
  eventReport,
  tripReport,
  stopReport,
  summaryReport,
  chartReport,
  emissionsReport,
  devicesInfoReport,
  dashboardReport,
  appVersion,
});

export { sessionActions } from './session';
export { devicesActions } from './devices';
export { positionsActions } from './positions';
export { geofencesActions } from './geofences';
export { groupsActions } from './groups';
export { driversActions } from './drivers';
export { maintenancesActions } from './maintenances';
export { usersActions } from './users';
export { notificationSettingsActions } from './notificationSettings';
export { computedAttributesActions } from './computedAttributes';
export { statisticsActions } from './statistics';
export { organizationActions } from './organizationInfo';
export { devicesSelectedActions } from './devicesSelected';
export { notificationsActions } from './notifications';
export { languageActions } from './language';
export { periodActions } from './period'
export { toggleTheme } from './theme';
export { replayPositionsActions } from './replayPositions';
export { routeReportActions } from './routeReport';
export { eventReportActions } from './eventReport';
export { tripReportActions } from './tripReport';
export { stopReportActions } from './stopReport';
export { summaryReportActions } from './summaryReport';
export { chartReportActions } from './chartReport';
export { emissionsReportActions } from './emissionsReport';
export { devicesInfoReportActions } from './devicesInfoReport';
export { dashboardReportActions } from './dashboardReport';
export { appVersionActions } from './appVersion';

export default configureStore({ reducer });
